
module.exports = {
    theme: {
        boxShadow: {
            custom: "0 3px 6px #999, 0 3px 6px #999"
        }
    }
};